import { render, staticRenderFns } from "./SupportingDocumentationForm.vue?vue&type=template&id=5c8817c7"
import script from "./SupportingDocumentationForm.vue?vue&type=script&lang=js"
export * from "./SupportingDocumentationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports